// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"96febfdd","485":"fcf0a9c4"}[chunkId] + ".chunk.js";
};